import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const POLL_MS = 10 * 60 * 1000; // aggiorna ogni 10 minuti (cache backend: 600s)

// Stato: "loading" | "ok" | "unavailable" — mai numeri inventati.
export default function useTelegramSubscribers() {
    const [status, setStatus] = useState("loading");
    const [count, setCount] = useState(null);
    const [pulse, setPulse] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const res = await fetch(`${API}/telegram/subscribers`);
                if (!res.ok) throw new Error("bad status");
                const data = await res.json();
                if (cancelled) return;
                if (data?.available && typeof data.count === "number") {
                    setCount((prev) => {
                        if (prev !== null && prev !== data.count) {
                            setPulse(true);
                            setTimeout(() => setPulse(false), 1300);
                        }
                        return data.count;
                    });
                    setStatus("ok");
                } else {
                    setStatus("unavailable");
                }
            } catch {
                if (!cancelled) setStatus("unavailable");
            }
        };
        load();
        const id = setInterval(load, POLL_MS);
        return () => {
            cancelled = true;
            clearInterval(id);
        };
    }, []);

    return { status, count, pulse };
}
